import { z } from 'zod';

export const validateAccountNumber = z
  .string()
  .regex(/^\d{7,11}$/, 'Account number must be between 7 and 11 digits long');
